module.exports = __webpack_public_path__ + "static/media/ar-help.08786cbd.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/features/pdfs/ar-help.pdf
// module id = 878
// module chunks = 4